import { useRef } from 'react';
import useInlineScript from '@/hooks/useInlineScript';
import { type IEmbedTelegram } from '@/types/IEmbeds';

export default function Telegram ({ id }: IEmbedTelegram) {
  const ref = useRef<HTMLDivElement>(null);

  useInlineScript(ref, `<script async src="https://telegram.org/js/telegram-widget.js?110" data-telegram-post="${id}" data-width="100%"></script>`);

  return <div ref={ref} />;
}
